import { InjectionToken } from '@angular/core';
import { Observable } from 'rxjs';
export const PROVIDER_SHOP_SERVICE_IMPL = new InjectionToken<IProviderShopService>(
    'providerShopServiceImpl'
);

export interface IProviderShopService {
    getUsersProviderShop(userID: string): Observable<number>;
}
